// dayjs format ref: https://day.js.org/docs/en/parse/string-format
export const DateTimeFormat = {
  date: "YYYY-MM-DD",
  time: "HH:mm",
  shortTime: "HHmm",
  datetime: "YYYY-MM-DD HH:mm",
};
export const TimeZone = "Asia/Taipei";
